/**
 * Site metadata constants for SEO and social sharing
 */

export const SITE_CONFIG = {
  name: "LetsGetVisa",
  title: "LetsGetVisa - U.S. Visa Application Portal",
  description:
    "Check your eligibility for U.S. citizenship and manage your visa application. Get expert guidance through the naturalization process with LetsGetVisa.",
  url: "https://letsgetvisa.com",
  image: "/og-image.png", // Default OG image (Github-Social.png)
  twitterHandle: "@letsgetvisa",
  locale: "en_US",
  type: "website",
} as const;

/**
 * Generate full URL for a given path
 */
export const getFullUrl = (path: string): string => {
  // If it's already a full URL, return as-is
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }
  
  const baseUrl = SITE_CONFIG.url.replace(/\/$/, "");
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  return `${baseUrl}${cleanPath}`;
};

/**
 * Generate page-specific metadata
 */
export interface PageMetadata {
  title: string;
  description: string;
  image?: string;
  path?: string;
  type?: string;
  noindex?: boolean;
}

/**
 * Get complete metadata object for a page
 */
export const getPageMetadata = (metadata: PageMetadata) => {
  const fullTitle = metadata.title.includes(SITE_CONFIG.name)
    ? metadata.title
    : `${metadata.title} | ${SITE_CONFIG.name}`;

  const url = metadata.path ? getFullUrl(metadata.path) : SITE_CONFIG.url;
  const image = metadata.image
    ? (metadata.image.startsWith("http") 
        ? metadata.image 
        : getFullUrl(metadata.image))
    : getFullUrl(SITE_CONFIG.image);

  return {
    title: fullTitle,
    description: metadata.description,
    url,
    image,
    type: metadata.type || SITE_CONFIG.type,
    noindex: metadata.noindex || false,
  };
};

